<template>
  <b-col>
    <b-card
      no-body
      class="p-2 border border-2"
    >
      <div class="flex justify-between">
        <div class="text-[#A0A0A0] flex gap-2">
          {{ title }}
        </div>
        <MonthFilter
          :month.sync="internalMonth"
          @month-change="handleMonthChange"
        />
      </div>
      <div class="font-poppins text-black mb-1 font-semibold text-[28px] leading-[38px] tracking-[0] align-middle mt-1">
        {{ formattedTotal }} <span
          class="rounded-lg px-[4px] font-poppins font-normal text-[12px] leading-[20px] tracking-[0] align-middle"
          :class="(percentage || '').includes('-') ? 'bg-[#FEE2E2] text-[#EF4444]' : 'bg-[#DCFCE7] text-[#22C55E]'"
        >
          {{ (percentage || '').replace('+', '') }}
        </span>
      </div>
      <div class="text-[#A0A0A0] text-sm">
        {{ lastMonthText }}
      </div>
    </b-card>
  </b-col>
</template>

<script>
import moment from 'moment'
import MonthFilter from './MonthFilter.vue'

export default {
  name: 'AiDashboardCard',
  components: {
    MonthFilter,
  },
  props: {
    title: { type: String, required: true },
    month: { type: [Date, String, Object], required: true },
    formattedTotal: { type: [String, Number], required: true },
    percentage: { type: String, required: true },
    lastMonthText: { type: String, required: true },
  },
  data() {
    return {
      moment,
    }
  },
  computed: {
    internalMonth: {
      get() {
        return this.month
      },
      set(val) {
        this.$emit('update:month', val)
      },
    },
  },
  methods: {
    handleMonthChange() {
      this.$emit('month-change')
    },
  },
}
</script>
